/**
 * Fetch a single user by ID.
 */
export const fetchUser = async (userId) => {
  const response = await fetch(`/api/user/${userId}`);
  if (!response.ok) throw new Error("Failed to fetch user");
  const data = await response.json();
  return data || {};
};

